import sileo from 'sileo';

const EmploymentPolicies = new sileo.Model('bposeats', 'employment-policies');
const CompanyEmploymentPolicies = new sileo.Model('bposeats', 'company-employment-policies');
const WorkforceEmployeeEmploymentPolicy = new sileo.Model('bposeats', 'workforce-employments-employment-policy');
const WorkforceEmployeeEmploymentPolicyCount = new sileo.Model('bposeats',
    'workforce-employments-employment-policy-count');
const CompanyEmploymentPoliciesCount = new sileo.Model('bposeats', 'company-employment-policies-count');
const EmploymentPolicyDetails = new sileo.Model('bposeats', 'employment-policy-details');
const WorkforceEmploymentPolicyDetails = new sileo.Model('bposeats', 'workforce-employment-policy-details');
const EmploymentPolicyEmployees = new sileo.Model('bposeats', 'employment-policy-employees');
const EmploymentPolicyApplicantPolicyContents = new sileo.Model(
    'bposeats', 'employment-policy-applicant-policy-contents');
const CompanyPayrollPolicies = new sileo.Model(
    'bposeats', 'company-payroll-policies');
const CountriesWithHoliday = new sileo.Model(
    'bposeats', 'countries-with-holiday');
const CountryHolidays = new sileo.Model(
    'bposeats', 'country-holidays');
const Holiday = new sileo.Model(
    'bposeats', 'holidays');
const LeavePolicy = new sileo.Model('bposeats', 'employer-leave-policies');
const LeavePolicyList = new sileo.Model('bposeats', 'employer-leave-policy-list');
const LeaveType = new sileo.Model('bposeats', 'leave-types');
const ApplicantPolicy = new sileo.Model('bposeats', 'employer-applicant-policy');
const IRPolicy = new sileo.Model('bposeats', 'ir-policy');
const IRPolicyAction = new sileo.Model('bposeats', 'ir-policy-action');
const IRPolicyOffenseRecommendedSanctions = new sileo.Model('bposeats', 'recommended-sanctions');
const IRPolicyOffense = new sileo.Model('bposeats', 'ir-policy-offense');
const PolicySection = new sileo.Model('bposeats', 'policy-section');
const AppraisalPolicy = new sileo.Model('bposeats', 'appraisal-policy');
const AmendEmploymentPolicy = new sileo.Model('bposeats', 'amend-employment-policy');
const CancelAmendEmploymentPolicy = new sileo.Model('bposeats', 'cancel-amend-employment-policy');
const HRAdmins = new sileo.Model('bposeats', 'hr-admins');
const HRAdminList = new sileo.Model('hqzen', 'hr-admins');
const Templates = new sileo.Model('bposeats', 'document-templates');
const PolicyCompanyDepartments = new sileo.Model('bposeats', 'policy-company-departments');
const RecentPolicyAmendment = new sileo.Model('bposeats', 'employment-policy-recent-amendment');
const IRPolicyAmendment = new sileo.Model('bposeats', 'ir-policy-recent-amendment');
const PolicyDepartmentTeamEmploymentsResource = new sileo.Model('bposeats', 'policy-department-team-employments');
const CompanySeparationPoliciesResource = new sileo.Model('hqzen', 'company-separation-policies');
const LeaveCatgeoryEmployees = new sileo.Model('bposeats', 'leave-category-employees');
// Temp. Remove these later
const HRAdminsCheck = new sileo.Model('bposeats', 'hr-admins-check');
const PermissionsEmploymentPolicies = new sileo.Model('bposeats', 'permissions-employment-policies');
const CareerPolicyPresets = new sileo.Model('hqzen', 'career-policy-presets');
const CareerPolicyList = new sileo.Model('hqzen', 'career-policy-draft');

const initialCareerPolicyData = () => ({
    name: '',
    timezone: '',
    assigned_hrs: [],
    applicant_policy: {},
    payroll_policy: {},
    leave_policy: {},
    overtime_policy: {},
    incident_report_policy: {},
    separation_policy: {},
    appraisal_policy: {},
    time_log_policy: {},
});

const state = {
    // Main career policy data being created/edited
    careerPolicyData: initialCareerPolicyData(),

    // Original data used for comparison (detect unsaved changes)
    originalPolicyData: {},

    // Names used for duplicate name validation
    allCareerPolicyNames: [],
};

const getters = {
    careerPolicyData: state => state.careerPolicyData,
    originalPolicyData: state => state.originalPolicyData,
    allCareerPolicyNames: state => state.allCareerPolicyNames,
};

const mutations = {
    setCareerPolicyFormData(state, data) {
        state.careerPolicyData = {
            ...state.careerPolicyData,
            ...data,
        };
    },

    setOriginalCareerPolicyFormData(state, data) {
        state.originalPolicyData = JSON.parse(JSON.stringify(data));
    },

    setCareerPolicyNames(state, data) {
        state.allCareerPolicyNames = data;
    },

    resetCareerPolicy(state) {
        state.careerPolicyData = initialCareerPolicyData();
        state.originalPolicyData = {};
        state.allCareerPolicyNames = [];
    },
};

const actions = {
    fetchEmploymentPolicies(context, filters) {
        return EmploymentPolicies.objects.filter(filters);
    },

    fetchCompanyEmploymentPolicies(context, filters) {
        return CompanyEmploymentPolicies.objects.filter(filters);
    },

    fetchCareerPolicyPresets(context, filters) {
        return CareerPolicyPresets.objects.filter(filters);
    },

    fetchCareerPolicyList(context, filters) {
        return CareerPolicyList.objects.filter(filters);
    },

    fetchPermissionsEmploymentPolicies(context, filters) {
        return PermissionsEmploymentPolicies.objects.filter(filters);
    },

    fetchWorkforceEmployeeEmploymentPolicy(context, filters) {
        return WorkforceEmployeeEmploymentPolicy.objects.filter(filters);
    },

    fetchWorkforceEmployeeEmploymentPolicyCount(context, filters) {
        return WorkforceEmployeeEmploymentPolicyCount.objects.filter(filters);
    },
    fetchCompanyEmploymentPoliciesCount(context, filters) {
        return CompanyEmploymentPoliciesCount.objects.filter(filters);
    },

    getEmploymentPolicyDetails(context, filters) {
        return filters.is_org_exec === true ? EmploymentPolicyDetails.objects.get(filters.pk):
            WorkforceEmploymentPolicyDetails.objects.get(filters.pk);
    },

    fetchEmploymentPolicyEmployees(context, filters) {
        let top = filters.top;
        delete filters.top;
        return EmploymentPolicyEmployees.objects.filter(filters, { top: top });
    },

    fetchLeaveCategoryEmployees(context, filters) {
        return LeaveCatgeoryEmployees.objects.filter(filters);
    },

    fetchEmploymentPolicyApplicantPolicyContents(context, filters) {
        return EmploymentPolicyApplicantPolicyContents.objects.filter(filters);
    },

    fetchCompanyPayrollPolicies(context, filters) {
        return CompanyPayrollPolicies.objects.filter(filters);
    },

    fetchCountriesWithHoliday(context, filters) {
        return CountriesWithHoliday.objects.filter(filters);
    },

    fetchCountryHolidays(context, filters) {
        return CountryHolidays.objects.filter(filters);
    },

    fetchHolidays(context, filters) {
        return Holiday.objects.filter(filters);
    },

    fetchLeavePolicies(context, filters = {}) {
        return LeavePolicyList.objects.filter(filters);
    },

    fetchLeavePolicyDetails(context, pk) {
        return LeavePolicy.objects.get(pk);
    },

    fetchCompanySeparationPolicies(context, filters = {}) {
        return CompanySeparationPoliciesResource.objects.filter(filters);
    },

    fetchLeaveTypes(context, filters = {}) {
        return LeaveType.objects.filter(filters);
    },

    fetchApplicantPolicy(context, filters) {
        return ApplicantPolicy.objects.filter(filters).then(data => {
            return data;
        }).catch(err => {
            return err;
        });
    },

    fetchIRPolicies(context, filters) {
        return IRPolicy.objects.filter(filters);
    },

    fetchIRPolicyActions(context, filters) {
        return IRPolicyAction.objects.filter(filters);
    },

    fetchRecommendedSanctions(context, filters) {
        return IRPolicyOffenseRecommendedSanctions.objects.filter(filters);
    },

    fetchIRPolicyOffenses(context, filters) {
        return IRPolicyOffense.objects.filter(filters);
    },

    fetchPolicySections(context, filters) {
        return PolicySection.objects.filter(filters);
    },

    fetchAppraisalPolicy(context, filters) {
        return AppraisalPolicy.objects.filter(filters);
    },

    getAmendEmploymentPolicy(context, pk) {
        return AmendEmploymentPolicy.objects.get(pk);
    },

    getEmploymentPolicyRecentAmendment(context, pk) {
        return RecentPolicyAmendment.objects.get(pk);
    },

    getIRPolicyRecentAmendment(context, pk) {
        return IRPolicyAmendment.objects.get(pk);
    },

    updateEmploymentPolicy(context, data) {
        const form = new FormData();

        for (let [key, value] of Object.entries(data)) {
            if (key !== 'pk')
                form.append(key, value);
        }

        return AmendEmploymentPolicy.objects.update({ 'pk': data.pk }, form);
    },

    cancelAmendEmploymentPolicy(context, filters) {
        return CancelAmendEmploymentPolicy.objects.update(filters);
    },

    fetchHRAdmins(context, filters) {
        return HRAdmins.objects.filter(filters);
    },

    // Temp. Remove this later
    fetchCheckHRAdmins(context, filters) {
        return HRAdminsCheck.objects.filter(filters);
    },

    fetchHRAdminList(context, filters) {
        return HRAdminList.objects.filter(filters);
    },

    fetchTemplates(context, filters) {
        let top = filters.top;
        delete filters.top;
        return Templates.objects.filter(filters, { top: top });
    },

    fetchPolicyCompanyDepartments(context, filters) {
        return PolicyCompanyDepartments.objects.filter(filters);
    },

    fetchDepartmentTeamEmployments(context, filters) {
        return PolicyDepartmentTeamEmploymentsResource.objects.filter(filters);
    },

    createEmploymentPolicy(context, form) {
        return CompanyEmploymentPolicies.objects.create(form);
    },

    createDraftEmploymentPolicy(context, form) {
        return CompanyEmploymentPolicies.objects.create(form);
    },

    deleteEmploymentPolicy(context, filters) {
        return CompanyEmploymentPolicies.objects.delete(filters);
    },
};

export default {
    namespaced: true,
    actions,
    state,
    getters,
    mutations,
};
